/**
 * The Mock Studio create actions, in the order they appear in the sidebar.
 *
 * A brand comes first because it is the prerequisite: a use case cannot render
 * without one.
 *
 * This lives in its own module rather than inside Sidebar.tsx so it can be unit
 * tested. Importing Sidebar pulls in services/api.ts, which reads `window` at
 * module load, and this project's test environment has no DOM.
 */
export interface MockStudioCreateAction {
  /** Each page opens its create modal on ?create=1. */
  readonly to: string
  readonly label: string
}

export const MOCK_STUDIO_CREATE_ACTIONS: ReadonlyArray<MockStudioCreateAction> = [
  { to: '/brands?create=1', label: 'New Brand' },
  { to: '/use-cases?create=1', label: 'New Use Case' },
]
